import { Card } from "@material-ui/core";
import { baseDomain } from "environment";
import { FC, ReactEventHandler, useCallback, useEffect, useState } from "react";
import CardShimmer from "./CardShimmer";

const CardImage: FC<{
  cardId: string;
  builderType: string;
}> = ({ cardId, builderType }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const [err, setErr] = useState(false);

  const [images, setImages] = useState<string[]>([]);

  const getImagePath = useCallback(() => {
    const dir =
      builderType === "PRO"
        ? "/assets/htmlcards/" + cardId
        : "/assets/enterprise_templates/" + cardId;

    const baseUrl = window.location.origin.includes("localhost")
      ? baseDomain
      : window.location.origin;

    return new URL(dir, baseUrl);
  }, [builderType, cardId]);

  const ImageComp: FC<{
    src: string;
    onLoad: ReactEventHandler;
    onError: ReactEventHandler;
  }> = ({ src, onLoad, onError }) => (
    <img
      src={src}
      alt="sample card"
      onLoad={onLoad}
      onError={onError}
      style={{
        display: imgLoaded ? "flex" : "none",
        width: "100%",
      }}
    />
  );

  useEffect(() => {
    setImages([
      getImagePath() + ".jpg?q=" + Date.now(),
      getImagePath() + ".png?q=" + Date.now(),
    ]);
  }, [getImagePath]);

  return (
    <Card style={{ marginTop: "5px", position: "relative" }}>
      {!err && (
        <ImageComp
          src={images[0]}
          onLoad={() => {
            setImgLoaded(true);
          }}
          onError={() => {
            setErr(true);
          }}
        />
      )}
      {err && (
        <ImageComp
          src={images[1]}
          onLoad={() => {
            setImgLoaded(true);
          }}
          onError={() => {
            setErr(false);
          }}
        />
      )}
      {!imgLoaded && <CardShimmer />}
    </Card>
  );
};

export default CardImage;
